angular

	.module 'App.Repository'
	.factory 'SuppliersRepository',
		[
			'BaseRepository',
			(BaseRepository) ->
				class SuppliersRepository extends BaseRepository
					@resource = '/suppliers'
					@isRestricted = true

				return new SuppliersRepository
		]
